import React from 'react'
import Layout from '../components/Layout'

const Roles = () => {
    return <Layout>Roles</Layout>
}

export default Roles
